import * as React from 'react';
import invariant from 'invariant';
import I18nPropTypes from '../../_prop-types';
import I18nContext from '../../_context';

var I18nProvider = function I18nProvider(_ref) {
  var i18n = _ref.i18n,
      children = _ref.children;
  var prevI18nInstance = React.useRef(null);
  React.useEffect(function () {
    prevI18nInstance.current = i18n;
  });
  invariant([i18n, null].includes(prevI18nInstance.current), "Le changement d'instance @insolus/i18n n'est pas pris en " + "charge par `I18nProvider`.");
  return React.createElement(I18nContext.Provider, {
    value: i18n
  }, React.Children.only(children));
};

export default I18nProvider;